import { contactUs } from '../data/contact-us';
import { Link } from 'react-router-dom';

const ContactTable = () => {
  return (
    <div className="bg-white p-8">
      {/* Info Section */}
      <div className="bg-gray-50 flex flex-col items-center">
        <h2 className="py-5 text-center text-3xl font-medium text-blue-800">
          Correspondence Address
        </h2>

        {/* Contact Sections */}
        <div className="grid grid-cols-1 items-center gap-8 gap-x-36 md:grid-cols-2 lg:grid-cols-3">
          {/* Section 1 */}
          <div className="max-w-xl border-l-4 border-orange-500 bg-white p-6 shadow-md">
            <p className="pb-2 text-2xl font-semibold">The Head, NCMRWF</p>
            <div className="pl-5 text-lg text-slate-600">
              Ministry of Earth Sciences
              <br />
              A-50, Sector-62, NOIDA, UP, Pin: 201 309
              <br />
              <span className="font-medium">Phone:</span> +91-120-2419401
              <br />
              <span className="font-medium">Fax:</span> +91-120-2419484
              <a className="ml-1 text-blue-600 hover:underline">
                View Route Map
              </a>
            </div>
          </div>

          {/* Section 2 */}
          <div className="max-w-xl border-l-4 border-orange-500 bg-white p-6 shadow-md">
            <p className="pb-2 text-2xl font-semibold">
              For Any Tender-Related Enquiries
            </p>
            <div className="pl-5 text-lg text-slate-600">
              <strong>Mr. Biswajit Guha</strong> (Deputy Secretary)
              <br />
              A-50, Sector-62, NOIDA, UP, Pin: 201 309
              <br />
              <span className="font-medium">Phone:</span> +91-120-2419480
              <br />
              <span className="font-medium">Fax:</span> +91-120-2419480
            </div>
          </div>

          {/* Section 3 */}
          <div className="max-w-xl border-l-4 border-orange-500 bg-white p-6 shadow-md">
            <p className="pb-2 text-2xl font-semibold">Useful Contact Links</p>
            <div className="flex flex-col space-y-3 pl-5 text-xl">
              <Link
                to="/contact-us/head"
                className="font-normal text-blue-600 hover:text-blue-800"
              >
                Telephone Office of Head, NCMRWF
              </Link>

              {/* //Todo left to use the reusable table to render the dynamic data for Telephone Directory - Scientists */}
              <a className="font-normal text-blue-600 hover:text-blue-800">
                Telephone Directory - Scientists
              </a>

              {/* //Todo left to use the reusable table to render the dynamic data for Telephone Directory - Administration*/}
              <a className="font-normal text-blue-600 hover:text-blue-800">
                Telephone Directory - Administration
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pt-24">
        <div className="gap-4 space-y-4">
          <p className="text-center text-3xl font-medium text-blue-800">
            MINISTRY OF HOUSING AND URBAN AFFAIRS NIRMAN BHAWAN, MAULANA AZAD
            ROAD, NEW DELHI-110011
          </p>
          <p className="text-center text-2xl font-medium text-blue-800">
            WEBSITE :{' '}
            <a
              href="http://www.mohua.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline hover:text-orange-400"
            >
              http://www.mohua.gov.in
            </a>
          </p>
          <p className="mb-6 text-center text-2xl font-medium text-blue-800">
            Hon’ble MINISTER OF STATE (Independent Charge) HOUSING AND URBAN
            AFFAIRS
          </p>
        </div>

        <div className="overflow-x-auto pt-4">
          <table className="w-full table-auto overflow-hidden rounded-2xl bg-white">
            <thead className="bg-blue-800 text-white">
              <tr className="border-b border-black">
                <th className="p-4 text-center text-sm font-semibold uppercase">
                  Name
                </th>
                <th className="p-4 text-sm font-semibold uppercase">
                  Designation
                </th>
                <th className="p-4 text-sm font-semibold uppercase">
                  EPABX No.
                </th>
                <th className="p-4 text-sm font-semibold uppercase">Hotline</th>
                <th className="p-4 text-sm font-semibold uppercase">
                  Office Telephone / Email
                </th>
                <th className="p-4 text-sm font-semibold uppercase">
                  Room No.
                </th>
                <th className="p-4 text-sm font-semibold uppercase">
                  Residence
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {contactUs.map((row) => (
                <tr
                  key={row.id}
                  className={`${
                    row.id % 2 !== 0 ? 'bg-white' : 'bg-slate-50'
                  } hover:bg-gray-100 transition`}
                >
                  <td className="p-4 font-medium">{row.name}</td>
                  <td className="p-4">{row.designation}</td>
                  <td className="p-4">{row.epabx}</td>
                  <td className="p-4">{row.hotline}</td>
                  <td className="p-4">
                    {row.contact}
                    <br />
                    <a
                      href={`mailto:${row.email}`}
                      className="text-blue-600 underline hover:text-blue-800"
                    >
                      {row.email}
                    </a>
                  </td>
                  <td className="p-4">{row.room}</td>
                  <td className="p-4">{row.residence}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ContactTable;
